import React, { useState, useEffect } from 'react';

const Visionn = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const sectionStyle = {
        padding: isMobile ? '0px' : '40px',
        margin: '0 auto',
    };

    const containerStyle = {
        maxWidth: isMobile ? '100%' : '1200px',
        margin: '0 auto',
        padding: '0 15px',
    };

    const rowStyle = {
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: 'center',
        gap: '20px',
    };

    const colStyle = {
        flex: '1',
        minWidth: isMobile ? '100%' : '300px',
        boxSizing: 'border-box',
        marginBottom: isMobile ? '20px' : '0',
    };

    const headingStyle = {
        textAlign: 'center',
        paddingBottom: '20px',
        fontSize: isMobile ? '24px' : '32px',
        color: '#343a40',
    };

    const visionContentStyle = {
        backgroundColor: '#631D02', 
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        textAlign: 'center',
        color: 'white',
    };

    const sectionTitleStyle = {
        color: '#631D02', // Light color for titles
    };
    const sectionTitleStylee = {
        color: 'white'
    };

    return (
        <section style={sectionStyle}>
            <div style={containerStyle}>
                <h3 style={{ ...headingStyle, ...sectionTitleStyle }}>About Our Vision & Mission</h3>
                <div style={rowStyle}>
                    <div style={colStyle}>
                        <div style={visionContentStyle}>
                            <h4 style={sectionTitleStylee}>Vision</h4>
                            <p className='text-white'>
                            At Mauli Cabs, our vision is to set new standards in travel by delivering safe, reliable, and customer-focused transportation solutions. We strive to provide a hassle-free travel experience by blending comfort, punctuality, and professionalism in every ride. With a strong commitment to customer satisfaction and continuous innovation, we aim to be a trusted partner for all your travel needs. By embracing modern technology and sustainable practices, Mauli Cabs envisions a future where urban and intercity travel is not only convenient and affordable but also eco-friendly and efficient.
                            </p>
                        </div>
                    </div>
                    <div style={colStyle}>
                        <div style={visionContentStyle}>
                            <h4 style={sectionTitleStylee}>Mission</h4>
                            <p className='text-white'>
                            At Mauli Cabs, our mission is to provide dependable, punctual, and customer-first transportation services that make every journey seamless and stress-free. We are dedicated to ensuring safety, comfort, and quality through rigorous driver training and the upkeep of a modern, well-maintained fleet. By actively listening to our passengers and continuously improving our offerings, we strive to deliver travel experiences that exceed expectations. Our focus is on building lasting relationships by making every ride with Mauli Cabs not just a trip—but a pleasant and memorable journey.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Visionn;
